import { FrontConf } from 'app/modules/global/domain/FrontConf';
import { updateContainerId } from 'app/modules/gtm/service/gtm.service';
import axios from 'axios';

export const ACTION_TYPES = {
  SET_CODE_APP: 'appManagementState/SET_CODE_APP',
  SET_FRONT_CONFIG: 'appManagementState/SET_FRONT_CONFIG',
  SET_WEB_SITE_CODE: 'appManagementState/SET_WEB_SITE_CODE'
};

const initialState = {
  productCode: '',
  websiteCode: '',
  frontConfig: {} as FrontConf,
  isReady: false
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_CODE_APP:
      return {
        ...state,
        productCode: action.payload,
      };
    case ACTION_TYPES.SET_FRONT_CONFIG:
      return {
        ...state,
        frontConfig: action.payload as FrontConf,
        isReady: true
      };
    case ACTION_TYPES.SET_WEB_SITE_CODE:
      return {
        ...state,
        websiteCode: action.payload,
      }
    default:
      return state;
  }
};

// Actions
export const getProductCode = () => async dispatch => {
  const apiUrl = `/global/product-code`;
  await axios
    .get(apiUrl)
    .then(response => {
      return dispatch({
        type: ACTION_TYPES.SET_CODE_APP,
        payload: response.data,
      });
    })
    .catch(err => { });
};

export const getFrontConfiguration: () => void = () => async (dispatch, getState) => {
  const apiUrl = `/global/front-config`;
  await axios
    .get(apiUrl)
    .then(response => {
      return dispatch({
        type: ACTION_TYPES.SET_FRONT_CONFIG,
        payload: response.data,
      });
    })
    .catch(err => { });

  const frontConfig = await getState().appManagement.frontConfig;
  if (frontConfig?.gtmContainerId) {
    await dispatch(updateContainerId(frontConfig.gtmContainerId));
  }
};


